export const API_URL = "https://childrenshealthcarecharity.org/k-api";
export const API_URL_DONATE =
	"https://childrenshealthcarecharity.org/k-donate/api";
export const API_URL_CONTACT =
	"https://childrenshealthcarecharity.org/k-contact/api";
export const API_URL_GRANTS =
	"https://childrenshealthcarecharity.org/k-grants/api";

//export const ZMSTER_API_URL = "https://api.sandbox.domain.com";

/*
	export const RECAPTCHA_KEY = "6LcVoMcUAAAAAEaWZppDop2tt9jUyclvGjyntdZO";
	export const AUTHNET_SCRIPT = "https://js.authorize.net/v1/Accept.js";
	export const AUTHNET_LOGINID = "879kHPaH";
	export const AUTHNET_PUBKEY =
		"426zXcntDAV86x2Z8gF2FT7bheDR4cHDq32Sfcc77aFYSz2PB7LVy59aj9FHsb3N";
*/

/* Authnet / Production
  export const AUTHNET_SCRIPT = "https://js.authorize.net/v1/Accept.js";
  export const AUTHNET_LOGINID = "879kHPaH";
  export const AUTHNET_PUBKEY = "426zXcntDAV86x2Z8gF2FT7bheDR4cHDq32Sfcc77aFYSz2PB7LVy59aj9FHsb3N";
*/

/* Authnet / Sandbox 
  export const AUTHNET_SCRIPT = "https://jstest.authorize.net/v1/Accept.js";
  export const AUTHNET_LOGINID = "34fhtk8Be8C7";
  export const AUTHNET_PUBKEY =
    "44S79RZmJ3jf7teah5u8wp95WCcRHX2rJ3S6a48Hx3t6w6jarbaRQFnGEaLVcLd6";
*/

const isBrowser = () => typeof window !== "undefined";

export const getObjFromLS = (key) =>
	isBrowser() && window.localStorage.getItem(key)
		? JSON.parse(window.localStorage.getItem(key))
		: undefined;

export const setObjToLS = (key, obj) => {
	if (isBrowser() && obj) {
		window.localStorage.setItem(key, JSON.stringify(obj));
	} else {
		window.localStorage.removeItem(key);
	}
	return true;
};

export const STATES = [
	{ value: "", name: "--" },
	{ value: "AL", name: "Alabama" },
	{ value: "AK", name: "Alaska" },
	{ value: "AZ", name: "Arizona" },
	{ value: "AR", name: "Arkansas" },
	{ value: "CA", name: "California" },
	{ value: "CO", name: "Colorado" },
	{ value: "CT", name: "Connecticut" },
	{ value: "DE", name: "Delaware" },
	{ value: "DC", name: "District of Columbia" },
	{ value: "FL", name: "Florida" },
	{ value: "GA", name: "Georgia" },
	{ value: "HI", name: "Hawaii" },
	{ value: "ID", name: "Idaho" },
	{ value: "IL", name: "Illinois" },
	{ value: "IN", name: "Indiana" },
	{ value: "IA", name: "Iowa" },
	{ value: "KS", name: "Kansas" },
	{ value: "KY", name: "Kentucky" },
	{ value: "LA", name: "Louisiana" },
	{ value: "ME", name: "Maine" },
	{ value: "MD", name: "Maryland" },
	{ value: "MA", name: "Massachusetts" },
	{ value: "MI", name: "Michigan" },
	{ value: "MN", name: "Minnesota" },
	{ value: "MS", name: "Mississippi" },
	{ value: "MO", name: "Missouri" },
	{ value: "MT", name: "Montana" },
	{ value: "NE", name: "Nebraska" },
	{ value: "NV", name: "Nevada" },
	{ value: "NH", name: "New Hampshire" },
	{ value: "NJ", name: "New Jersey" },
	{ value: "NM", name: "New Mexico" },
	{ value: "NY", name: "New York" },
	{ value: "NC", name: "North Carolina" },
	{ value: "ND", name: "North Dakota" },
	{ value: "OH", name: "Ohio" },
	{ value: "OK", name: "Oklahoma" },
	{ value: "OR", name: "Oregon" },
	{ value: "PA", name: "Pennsylvania" },
	{ value: "PR", name: "Puerto Rico" },
	{ value: "RI", name: "Rhode Island" },
	{ value: "SC", name: "South Carolina" },
	{ value: "SD", name: "South Dakota" },
	{ value: "TN", name: "Tennessee" },
	{ value: "TX", name: "Texas" },
	{ value: "UT", name: "Utah" },
	{ value: "VT", name: "Vermont" },
	{ value: "VI", name: "Virgin Islands" },
	{ value: "VA", name: "Virginia" },
	{ value: "WA", name: "Washington" },
	{ value: "WV", name: "West Virginia" },
	{ value: "WI", name: "Wisconsin" },
	{ value: "WY", name: "Wyoming" },
];

export const COUNTIES = [
	"Alachua",
	"Baker",
	"Bay",
	"Bradford",
	"Brevard",
	"Broward",
	"Calhoun",
	"Charlotte",
	"Citrus",
	"Clay",
	"Collier",
	"Columbia",
	"DeSoto",
	"Dixie",
	"Duval",
	"Escambia",
	"Flagler",
	"Franklin",
	"Gadsden",
	"Gilchrist",
	"Glades",
	"Gulf",
	"Hamilton",
	"Hardee",
	"Hendry",
	"Hernando",
	"Highlands",
	"Hillsborough",
	"Holmes",
	"Indian River",
	"Jackson",
	"Jefferson",
	"Lafayette",
	"Lake",
	"Lee",
	"Leon",
	"Levy",
	"Liberty",
	"Madison",
	"Manatee",
	"Marion",
	"Martin",
	"Miami-Dade",
	"Monroe",
	"Nassau",
	"Okaloosa",
	"Okeechobee",
	"Orange",
	"Osceola",
	"Palm Beach",
	"Pasco",
	"Pinellas",
	"Polk",
	"Putnam",
	"Santa Rosa",
	"Sarasota",
	"Seminole",
	"St. Johns",
	"St. Lucie",
	"Sumter",
	"Suwannee",
	"Taylor",
	"Union",
	"Volusia",
	"Wakulla",
	"Walton",
	"Washington",
];

export const RACES = [
	{ value: "", name: "--" },
	{
		value: "American Indian or Alaska Native",
		name: "American Indian or Alaska Native",
	},
	{ value: "White", name: "White" },
	{ value: "Asian", name: "Asian" },
	{ value: "Black or African American", name: "Black or African American" },
	{ value: "Hispanic or Latino", name: "Hispanic or Latino" },
	{
		value: "Native Hawaiian or Other Pacific Islander",
		name: "Native Hawaiian or Other Pacific Islander",
	},
	{ value: "Not Specified", name: "Not Specified" },
	{ value: "Two or More Races", name: "Two or More Races" },
	{ value: "I choose not to answer", name: "I choose not to answer" },
];

export const RACESAMBASS = [
	{ value: "", name: "--" },
	{ value: "Asian", name: "Asian" },
	{ value: "Black or African American", name: "Black or African American" },
	{ value: "Hispanic or Latino", name: "Hispanic or Latino" },
	{
		value: "Native Hawaiian or Other Pacific Islander",
		name: "Native Hawaiian or Other Pacific Islander",
	},
	{ value: "White", name: "White" },
	{ value: "Not Specified", name: "Not Specified" },
	{ value: "Two or More Races", name: "Two or More Races" },
	{ value: "I choose not to answer", name: "I choose not to answer" },
];

export const fmtCurrency = (int) => {
	const amt = int;
	const fmtAmt = `${amt.toLocaleString("en-US", {
		style: "currency",
		currency: "USD",
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	})}`;

	return fmtAmt.replace("$", "$ ");
};

export function createMarkup(html) {
	return { __html: html };
}

export const isCardType = (str) => {
	if (str) {
		str = str.replace(/\s/g, "").replace(/-/g, "");
		const visa = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;
		const mast = /^(?:5[1-5][0-9]{14})$/;
		const amex = /^(?:3[47][0-9]{13})$/;
		const disc = /^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/;
		if (str.match(visa)) {
			return "visa";
		} else if (str.match(mast)) {
			return "mastercard";
		} else if (str.match(amex)) {
			return "amex";
		} else if (str.match(disc)) {
			return "discover";
		} else {
			return "no";
		}
	} else {
		return "no";
	}
};
